import ApplyForm from '@/components/ApplyForm'
import type { SectionOf } from './shared'

/**
 * The application form on a role page. `id="apply"` is what every "Apply now"
 * button on the page points at, the way `#contact` is the contact band's.
 */
export default function ApplySection({ section }: { section: SectionOf<'apply'> }) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center gap-10" id="apply">
      <div className="text-center">
        <h2 className="text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
          {section.heading}
        </h2>
        {section.sub && (
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground sm:text-xl">{section.sub}</p>
        )}
      </div>
      <div className="w-full">
        <ApplyForm opening={section.opening} />
      </div>
    </div>
  )
}
